import apiClient from "./apiClient";

const Url = `/communication`;

export const getCommunications = async ( props ,currentPage ,rowsPerPage ,searchText) => {
 try {
    let url = `${Url}/list?page=${currentPage}&limit=${rowsPerPage}`;

    if (searchText !== null && searchText !== undefined && searchText.trim() !== "") {
      url += `&search=${encodeURIComponent(searchText.trim())}`;
    }

    let response = await apiClient.get(url);

    return response.data;
  } catch (error) {
    console.log("error", error, error.response);
    return error;
  }
};

export const getCommunicationDetail = async (payload, props) => {
  try {
    if (!payload || !payload.communicationId) return false;

    let response = await apiClient.get(`${Url}/${payload.communicationId}`);

    if (response && response.status === 200) return response.data;
    return response;
  } catch (error) {
    console.log("error", error, error.response);
    return error;
  }
};

export const addCommunication = async (props, Data) => {
  try {
    let body = {
      date: Data.date,
      time: Data.time,
      type: Data.type,
      channel: Data.channel,
      relatedTo: Data.relatedTo,
      name: Data.name,
      subject: Data.subject,
      customerId: Data?.customerId?._id || Data?.customerId,
      sentBy: Data.sentBy
    };

    let response = await apiClient.post(Url, body);

    return response;
  } catch (error) {
    console.log("error", error, error.response);
    return error;
  }
};

export const editCommunication = async (props, Data, editId) => {
  try {
    let body = {
      date: Data.date,
      time: Data.time,
      type: Data.type,
      channel: Data.channel,
      relatedTo: Data.relatedTo,
      name: Data.name,
      subject: Data.subject,
      customerId: Data?.customerId?._id || Data?.customerId,
      sentBy: Data.sentBy
    };

    let response = await apiClient.put(
      `${Url}?communicationId=${editId}`,
      body,
    );

    if (response && response.status === 200) return response.data;
    return response;
  } catch (error) {
    console.log("error", error, error.response);
    return error;
  }
};

export const deleteCommunications = async (communicationId, props) => {
  try {
    if (!communicationId) return false;

    let response = await apiClient.delete(
      `${Url}?communicationId=${communicationId}`,
    );

    return response;
  } catch (error) {
    console.log("error", error, error.response);
    return error;
  }
};

export const getCommunicationsbycustomerId = async ( props , customerId) => {
 try {
    let url = `${Url}/list?customerId=${customerId}`;

    let response = await apiClient.get(url);

    return response.data;
  } catch (error) {
    console.log("error", error, error.response);
    return error;
  }
};
